(function (root, factory) {
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.FBRemindersAPI = api;
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';

  var ME_KEY = 'fb_rem_me';
  var ME_TTL = 60 * 1000;
  // Historical signed tokens can still accompany requests, but the concluded
  // experiment no longer uses them to choose or publish an offer.
  var TOKEN_KEY = 'fb_rem_reward_token';
  var TOKEN_RE = /^(free_delivery|pct30)\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;

  // Percentage offers and their size. The backend names the offer (its
  // rewardOfferArm for guests, datesReward.arm for members); the copy follows
  // it, so the site and the code granted always agree. pct30 codes issued
  // before 12 Oct 2026 keep 30%.
  var PCT_ARMS = { pct30: 30, pct10: 10 };
  function isPctArm(arm) { return typeof arm === 'string' && Object.prototype.hasOwnProperty.call(PCT_ARMS, arm); }
  function armPercent(arm) { return isPctArm(arm) ? PCT_ARMS[arm] : PCT_ARMS.pct10; }
  /* preseed20 is the signed-in pre-seed campaign. The 20% code arrives with
     the first reminder, so the site shows no three-dates or percentage
     prompt for it. Any other non-empty member arm that is not pct10 or
     pct30 is quiet the same way. free_delivery stays a real issued arm. */
  function quietMemberArm(arm) {
    return typeof arm === 'string' && arm && !isPctArm(arm) && arm !== 'free_delivery' && arm !== 'none' && arm !== 'off';
  }
  /* The offer for anyone without an issued code.
     Guests follow rewardOfferArm; a missing guest arm is 10%.
     A signed-in member with no datesReward, or a datesReward that names
     no arm, keeps that 10% fallback. A named non-percentage arm does not. */
  function offerArm(data) {
    var reward = data && data.signedIn === true && data.member && data.member.datesReward;
    var arm = reward ? reward.arm : data && data.signedIn === false ? data.rewardOfferArm : null;
    var source = reward || (data && data.signedIn === false ? data : null);
    var key = reward ? 'arm' : 'rewardOfferArm';
    var issued = reward && ['pending', 'earned', 'redeemed', 'expired'].indexOf(reward.status) >= 0;
    if (!issued && source && Object.prototype.hasOwnProperty.call(source, key) && (arm === null || arm === 'none' || arm === 'off')) return 'none';
    if (reward && typeof arm === 'string' && arm && !isPctArm(arm)) return null;
    return isPctArm(arm) ? arm : 'pct10';
  }

  // Only explicit no-offer answers touch these surfaces. Observe late drawer
  // renders while disabled, and restore their prior state if an offer returns.
  var hiddenOffers = [], offerObserver;
  function hideOfferSurfaces(arm) {
    if (arm !== 'none') {
      if (offerObserver) offerObserver.disconnect();
      offerObserver = null;
      hiddenOffers.forEach(function (saved) {
        saved.node.hidden = saved.hidden;
        saved.node.style.display = saved.display;
        saved.node.style.animation = saved.animation;
      });
      hiddenOffers = [];
      return;
    }
    var doc = root.document;
    if (!doc || !doc.querySelectorAll) return;
    function remember(node) {
      if (!hiddenOffers.some(function (saved) { return saved.node === node; })) {
        hiddenOffers.push({ node: node, hidden: node.hidden, display: node.style.display, animation: node.style.animation });
      }
    }
    function hide() {
      doc.querySelectorAll('.fb-reminders-pdp-hook, .fb-reminders-cart-hook, .fb-rem-drawer-line, .fb-rem-pct, .fb-rem-free, .fb-journal-reminders, .fb-ann-rotate__alt').forEach(function (node) {
        remember(node);
        node.hidden = true;
        node.style.display = 'none';
      });
      doc.querySelectorAll('.fb-ann-rotate > *').forEach(function (node) {
        remember(node);
        node.style.animation = 'none';
      });
    }
    hide();
    if (!offerObserver && typeof root.MutationObserver === 'function') {
      offerObserver = new root.MutationObserver(hide);
      offerObserver.observe(doc.documentElement, { childList: true, subtree: true });
    }
  }

  // Welcome reads /me independently and publishes its accepted answer here.
  if (root.document && root.document.addEventListener) {
    root.document.addEventListener('fb-reminders:state', function (event) {
      var data = event.detail && event.detail.me;
      if (data) hideOfferSurfaces(offerArm(data));
    });
  }

  function storage() {
    try { return root.sessionStorage || null; } catch (_) { return null; }
  }

  /* A lasting "this browser has a signed-in member" flag: '1' or absent,
     never who the member is. sections/fb-reminders-app.liquid reads it
     before first paint and holds the Reminders page at a screen's height,
     so the member's view replacing the short server shell does not push
     the footer down (a layout shift). Updated on every fresh /me answer. */
  var MEMBER_KEY = 'fb_rem_member';

  function rememberMember(signedIn) {
    var store;
    try { store = root.localStorage || null; } catch (_) { return; }
    if (!store) return;
    try {
      if (signedIn) store.setItem(MEMBER_KEY, '1');
      else store.removeItem(MEMBER_KEY);
    } catch (_) {}
  }

  function validRewardToken(token) {
    return typeof token === 'string' && token.length <= 200 && TOKEN_RE.test(token);
  }

  function rewardToken() {
    var kinds = ['localStorage', 'sessionStorage'];
    for (var i = 0; i < kinds.length; i++) {
      try {
        var token = root[kinds[i]] && root[kinds[i]].getItem(TOKEN_KEY);
        if (validRewardToken(token)) return token;
      } catch (_) {}
    }
    return validRewardToken(root.FBRemindersRewardToken) ? root.FBRemindersRewardToken : null;
  }

  function meRevision() { return Number(root.FBRemindersMeRevision) || 0; }
  function nextMeRead() {
    root.FBRemindersMeReadSequence = (Number(root.FBRemindersMeReadSequence) || 0) + 1;
    return root.FBRemindersMeReadSequence;
  }

  /* The sheet and page can finish /me before welcome.js, or without it.
     Publish the winner for guests and unissued rewards; issued rewards keep
     their original terms, including the pre-experiment free-delivery default. */
  function publishMe(data, sequence) {
    if (!data) return;
    var member = data.signedIn === true && data.member;
    var reward = member && member.datesReward;
    var quiet = reward && quietMemberArm(reward.arm);
    var arm = quiet ? null : offerArm(data);
    if (!quiet && reward && ['pending', 'earned', 'redeemed', 'expired'].indexOf(reward.status) >= 0) {
      arm = isPctArm(reward.arm) ? reward.arm : 'free_delivery';
    }
    hideOfferSurfaces(arm);
    var state = member ? 'member' : 'guest';
    if (quiet) state = 'member';
    else if (reward) {
      if (reward.status === 'locked') state = Math.max(0, Math.min(reward.dated || 0, reward.threshold)) === 0 ? 'guest' : 'progress';
      else if (reward.status === 'pending') state = 'pending';
      else if (reward.status === 'earned' && typeof reward.code === 'string' && /^REMIND-[A-Za-z0-9]{4,32}$/.test(reward.code) && !(reward.expiresAt && Date.parse(reward.expiresAt) <= Date.now())) state = 'earned';
    }
    root.FBRemindersCurrentMe = { revision: meRevision(), sequence: sequence == null ? nextMeRead() : sequence, me: data };
    rememberMember(!!member);
    try {
      var el = root.document.documentElement;
      if (arm) el.setAttribute('data-fb-rem-arm', arm);
      else if (typeof el.removeAttribute === 'function') el.removeAttribute('data-fb-rem-arm');
      el.setAttribute('data-fb-rem-state', state);
      if (typeof root.CustomEvent === 'function') root.document.dispatchEvent(new root.CustomEvent('fb-reminders:me', { detail: { me: data } }));
    } catch (_) {}
  }

  function ApiError(message, options) {
    options = options || {};
    this.name = 'FBRemindersApiError';
    this.message = message || 'Request failed';
    this.status = options.status || 0;
    this.code = options.code || 'REQUEST_FAILED';
    this.field = options.field || null;
    this.retryInSeconds = options.retryInSeconds || null;
    this.payload = options.payload || null;
    if (Error.captureStackTrace) Error.captureStackTrace(this, ApiError);
  }
  ApiError.prototype = Object.create(Error.prototype);
  ApiError.prototype.constructor = ApiError;

  function mappedCode(status, payload) {
    if (payload && payload.error && payload.error.code) return payload.error.code;
    if (status === 401) return 'UNAUTHENTICATED';
    if (status === 403) return 'FORBIDDEN_ORIGIN';
    if (status === 429) return 'RATE_LIMITED';
    if (status === 404) return 'NOT_FOUND';
    if (status === 503) return 'INTERNAL';
    return 'REQUEST_FAILED';
  }

  // Pre-seed bearer tokens travel only in X-FB-Preseed-Token. Birthday Club's
  // generator was not readable from this session. Base64url (A-Za-z0-9_-) is
  // the minimum, including long unpadded tokens. The same alphabet as the
  // head script also allows standard base64 (+, /) and up to two trailing
  // equals. Anything else is refused before a request is built.
  var PRESEED_TOKEN_RE = /^[A-Za-z0-9._~+/-]{8,2048}={0,2}$/;
  function validPreseedToken(token) {
    return typeof token === 'string' && PRESEED_TOKEN_RE.test(token);
  }

  function create(baseUrl, options) {
    options = options || {};
    var fetchImpl = options.fetch || root.fetch;
    var now = options.now || Date.now;
    if (typeof fetchImpl !== 'function') throw new Error('fetch is required');
    var base = String(baseUrl || '').replace(/\/+$/, '');

    /* A read the page started before this script loaded
       (sections/fb-reminders-app.liquid puts the person view's shop read on
       window.FBRemindersPrefetch, keyed by path). Used once; a failed one
       falls back to a fresh fetch. */
    function takePrefetch(path) {
      try {
        var store = root.FBRemindersPrefetch;
        if (!store || !Object.prototype.hasOwnProperty.call(store, path)) return null;
        var pending = store[path];
        delete store[path];
        return pending && typeof pending.then === 'function' ? pending : null;
      } catch (_) { return null; }
    }

    function mutationScope(path, method) {
      if (method === 'GET' || method === 'HEAD') return null;
      var clean = path.split('?')[0], match;
      if ((match = /^\/friends\/([^/]+)\/(details|preferences|items)$/.exec(clean))) return { kind: 'friend', id: decodeURIComponent(match[1]) };
      if ((match = /^\/occasions\/([^/]+)(?:\/shop)?$/.exec(clean))) return { kind: 'occasion', id: decodeURIComponent(match[1]) };
      // These writes can change links/identity or owner-list signals without a
      // friend id in the URL. Invalidate all open recipient context locally.
      if (/^\/(wishlist\/(me|shared|link|unlink)|occurrences\/|auth\/|me\/flowers|flowers\/favourites)/.test(clean)) return { kind: 'all', id: null };
      return null;
    }
    function announceMutation(detail) {
      try { if (root.document && typeof root.CustomEvent === 'function') root.document.dispatchEvent(new root.CustomEvent('fb-recipient-context:mutation', { detail: detail })); } catch (_) {}
    }
    async function request(path, requestOptions) {
      var scope = mutationScope(path, String(requestOptions && requestOptions.method || 'GET').toUpperCase());
      if (!scope) return performRequest(path, requestOptions);
      var mutation = (Number(root.FBRecipientMutationSequence) || 0) + 1;
      root.FBRecipientMutationSequence = mutation;
      // A server-render prefetch may predate this write and must not be reused.
      root.FBRemindersPrefetch = {};
      announceMutation({ id: mutation, phase: 'begin', scope: scope });
      var ok = false;
      try { var result = await performRequest(path, requestOptions); ok = true; return result; }
      finally { announceMutation({ id: mutation, phase: 'settled', scope: scope, ok: ok }); }
    }
    async function performRequest(path, requestOptions) {
      requestOptions = requestOptions || {};
      var method = requestOptions.method || 'GET';
      var init = {
        method: method,
        credentials: 'include',
        headers: { 'Accept': 'application/json' }
      };
      // A GET with only Accept is a simple CORS request: no preflight round
      // trip before it. Writes still declare JSON (the API's CSRF check needs
      // it), and the reward arm token goes only where the API reads it: /me
      // and the writes (sign-in, invites).
      var reads = method === 'GET';
      if (!reads) init.headers['Content-Type'] = 'application/json';
      var token = rewardToken();
      if (token && (!reads || /^\/me(\?|$)/.test(path))) init.headers['X-FB-Reward-Arm'] = token;
      // Caller headers are copied after the defaults. The pre-seed bearer is
      // accepted only when it matches PRESEED_TOKEN_RE, and only as a header.
      if (requestOptions.headers) {
        Object.keys(requestOptions.headers).forEach(function (name) {
          var value = requestOptions.headers[name];
          if (typeof value !== 'string' || value.indexOf('\n') !== -1 || value.indexOf('\r') !== -1) return;
          if (name === 'X-FB-Preseed-Token' || name === 'X-FB-Preseed-Unsub') {
            if (validPreseedToken(value)) init.headers[name] = value;
            return;
          }
          init.headers[name] = value;
        });
      }
      if (Object.prototype.hasOwnProperty.call(requestOptions, 'body')) {
        init.body = JSON.stringify(requestOptions.body);
      }

      var response;
      try {
        var early = method === 'GET' ? takePrefetch(path) : null;
        if (early) {
          try { response = await early; } catch (_) { response = null; }
        }
        if (!response) response = await fetchImpl(base + '/api/v1' + path, init);
      } catch (error) {
        throw new ApiError(error && error.message ? error.message : 'Network error', { code: 'NETWORK_ERROR' });
      }

      var payload = null;
      try { payload = await response.json(); } catch (_) {}
      if (!response.ok || (payload && payload.ok === false)) {
        var errorBody = payload && payload.error ? payload.error : {};
        throw new ApiError(errorBody.message || 'Request failed', {
          status: response.status,
          code: mappedCode(response.status, payload),
          field: errorBody.field,
          retryInSeconds: payload && (payload.retryInSeconds || errorBody.retryInSeconds),
          payload: payload
        });
      }
      return payload || { ok: true };
    }

    function readCachedMe() {
      var store = storage();
      if (!store) return null;
      try {
        var cached = JSON.parse(store.getItem(ME_KEY) || 'null');
        if (!cached || !cached.data || cached.expiresAt <= now()) {
          try { store.removeItem(ME_KEY); } catch (_) {}
          return null;
        }
        return cached.data;
      } catch (_) {
        try { store.removeItem(ME_KEY); } catch (_) {}
        return null;
      }
    }

    function cacheMe(data) {
      var store = storage();
      if (!store) return;
      try { store.setItem(ME_KEY, JSON.stringify({ expiresAt: now() + ME_TTL, data: data })); } catch (_) {}
    }

    async function me(options) {
      options = options || {};
      var revision = meRevision();
      var current = root.FBRemindersCurrentMe;
      var cached = options.force ? null : readCachedMe();
      if (cached) {
        // A failed storage write can leave an older cache behind. Cached
        // reads reuse the accepted answer and never gain fresh-read priority.
        var known = current && current.revision === revision;
        if (known) cached = current.me;
        publishMe(cached, known ? current.sequence || 0 : 0);
        return cached;
      }
      var sequence = nextMeRead();
      var data = await request('/me');
      // Verification or a save invalidated this in-flight answer. Never put
      // its old guest/account state back on screen or hand it to the sheet.
      if (revision !== meRevision()) {
        current = root.FBRemindersCurrentMe;
        if (current && current.revision > revision) return current.me;
        if (options.retried) throw new ApiError('Your reminders changed. Please try again.', { code: 'STALE_RESPONSE' });
        return me({ force: true, retried: true });
      }
      // Welcome and all API instances share this ordering. Only a newer
      // successful answer supersedes this read; a pending/failed one cannot.
      current = root.FBRemindersCurrentMe;
      if (current && current.revision === revision && current.sequence > sequence) return current.me;
      cacheMe(data);
      publishMe(data, sequence);
      return data;
    }

    function clearMe() {
      root.FBRemindersMeRevision = meRevision() + 1;
      var store = storage();
      if (store) {
        try { store.removeItem(ME_KEY); } catch (_) {}
      }
    }

    async function verifyIdentity(path, body) {
      var response = await request(path, { method: 'POST', body: body });
      clearMe();
      if (response.member) {
        var data = { signedIn: true, member: response.member };
        cacheMe(data);
        publishMe(data);
      }
      return response;
    }

    function preseedRequest(path, token, requestOptions) {
      if (!validPreseedToken(token)) {
        return Promise.reject(new ApiError('Request failed', { status: 401, code: 'PRESEED_TOKEN_INVALID' }));
      }
      var options = { method: requestOptions && requestOptions.method || 'GET', headers: { 'X-FB-Preseed-Token': token } };
      if (requestOptions && Object.prototype.hasOwnProperty.call(requestOptions, 'body')) options.body = requestOptions.body;
      return request(path, options);
    }

    return {
      request: request,
      announcesRecipientMutations: true,
      me: me,
      clearMe: clearMe,
      createOccasion: function (body) { return request('/occasions', { method: 'POST', body: body }); },
      requestEmailCode: function (email) { return request('/auth/email/request', { method: 'POST', body: { email: email } }); },
      verifyEmailCode: function (body) { return verifyIdentity('/auth/email/verify', body); },
      requestSmsCode: function (phone) { return request('/auth/sms/request', { method: 'POST', body: { phone: phone } }); },
      verifySmsCode: function (body) { return verifyIdentity('/auth/sms/verify', body); },
      getNewsletter: function () { return request('/newsletter'); },
      subscribeNewsletter: function () { return request('/newsletter', { method: 'POST', body: { consent: true, version: 'reminders_post_save_v1' } }); },
      getPreferences: function () { return request('/preferences'); },
      putPreferences: function (body) { return request('/preferences', { method: 'PUT', body: body }); },
      /* T2: the page (list, person, manage, settings, invite, link). */
      getOccasions: function () { return request('/occasions'); },
      getShop: function (id) { return request('/occasions/' + encodeURIComponent(id) + '/shop'); },
      getShopPage: function (id, group, offset) { return request('/occasions/' + encodeURIComponent(id) + '/shop?group=' + encodeURIComponent(group) + '&offset=' + encodeURIComponent(offset)); },
      patchShop: function (id, body) { return request('/occasions/' + encodeURIComponent(id) + '/shop', { method: 'PATCH', body: body }); },
      createRecipientRequest: function (friendId, body) { return request('/people/' + encodeURIComponent(friendId) + '/request', { method: 'POST', body: body }); },
      patchOccasion: function (id, body) { return request('/occasions/' + encodeURIComponent(id), { method: 'PATCH', body: body }); },
      deleteOccasion: function (id) { return request('/occasions/' + encodeURIComponent(id), { method: 'DELETE' }); },
      occurrenceOutcome: function (id, body) { return request('/occurrences/' + encodeURIComponent(id) + '/outcome', { method: 'POST', body: body }); },
      resolveLink: function (token) { return request('/r/' + encodeURIComponent(token)); },
      getBirthdayInvitation: function (token) { return request('/birthday-invitations/' + encodeURIComponent(token)); },
      acceptBirthdayInvitation: async function (token, body) { var result = await request('/birthday-invitations/' + encodeURIComponent(token) + '/accept', { method: 'POST', body: body }); clearMe(); return result; },
      logout: async function () { var result = await request('/auth/logout', { method: 'POST', body: {} }); clearMe(); publishMe({ signedIn: false }); return result; },
      getInvite: function (token) { return request('/invites/' + encodeURIComponent(token)); },
      acceptInvite: function (token, body) { return request('/invites/' + encodeURIComponent(token) + '/accept', { method: 'POST', body: body }); },
      declineInvite: function (token, body) { return request('/invites/' + encodeURIComponent(token) + '/decline', { method: 'POST', body: body || {} }); },
      /* Favourite flowers (assets/fb-favourite-flowers.js). */
      saveFlowerFavourites: function (body) { return request('/flowers/favourites', { method: 'POST', body: body }); },
      getMyFlowers: function () { return request('/me/flowers'); },
      putMyFlowers: function (body) { return request('/me/flowers', { method: 'PUT', body: body }); },
      /* Logged-out pre-seed links. The bearer is the header only. */
      getPreseed: function (token) { return preseedRequest('/preseed', token, { method: 'GET' }); },
      preseedConfirm: function (token, body) {
        return preseedRequest('/preseed/confirm', token, { method: 'POST', body: { id: body && body.id, day: body && body.day } });
      },
      preseedSaveAll: function (token, body) {
        var days = body && body.days && typeof body.days === 'object' ? body.days : {};
        var clean = {};
        Object.keys(days).forEach(function (id) { clean[id] = days[id]; });
        return preseedRequest('/preseed/save-all', token, { method: 'POST', body: { days: clean } });
      },
      preseedAdd: function (token, body) {
        return preseedRequest('/preseed/add', token, { method: 'POST', body: {
          name: body && body.name,
          month: body && body.month,
          day: body && body.day
        } });
      },
      preseedRemove: function (token, body) { return preseedRequest('/preseed/remove', token, { method: 'POST', body: { id: body && body.id } }); },
      preseedDelete: function (token) { return preseedRequest('/preseed/delete', token, { method: 'POST', body: {} }); },
      preseedUnsubscribe: function (token, unsub) {
        var headers = {};
        if (validPreseedToken(unsub)) headers['X-FB-Preseed-Unsub'] = unsub;
        else if (validPreseedToken(token)) headers['X-FB-Preseed-Token'] = token;
        else return Promise.reject(new ApiError('Request failed', { status: 401, code: 'PRESEED_TOKEN_INVALID' }));
        return request('/preseed/unsubscribe', { method: 'POST', body: {}, headers: headers });
      },
      preseedOtpRequest: function (token) { return preseedRequest('/preseed/otp/request', token, { method: 'POST', body: {} }); },
      preseedOtpVerify: function (token, body) {
        return preseedRequest('/preseed/otp/verify', token, { method: 'POST', body: { code: body && typeof body.code === 'string' ? body.code : '' } });
      }
    };
  }


  // Post-verify newsletter ask (snippets/fb-reminders-keep-posted.liquid), used
  // by the sheet's saved state and /pages/reminders-success. Shown only when the
  // verified email is eligible. "Yes please" records consent server-side for
  // that verified email (POST /newsletter); "No thanks" just dismisses.
  function keepPosted(section, client, track) {
    if (!section) return { show: function () { return Promise.resolve(false); }, hide: function () {} };
    if (section.__keepPosted) return section.__keepPosted;
    var status = section.querySelector('[data-keep-posted-status]');
    var actions = section.querySelector('[data-keep-posted-actions]');
    var busy = false, done = false;
    function emit(name, props) { try { if (track) track(name, props); } catch (_) {} }
    function lock(on) { section.querySelectorAll('[data-keep-posted]').forEach(function (b) { b.disabled = on; }); }
    var failed = 'We couldn’t save that just now. Please try again.';
    section.addEventListener('click', async function (event) {
      var button = event.target && event.target.closest ? event.target.closest('[data-keep-posted]') : null;
      if (!button || busy || done) return;
      if (button.dataset.keepPosted === 'no') { done = true; section.hidden = true; emit('keep_posted_declined'); return; }
      busy = true; lock(true); if (status) status.textContent = '';
      emit('keep_posted_requested');
      try {
        var result = await client.subscribeNewsletter();
        if (result && (result.status === 'enrolled' || result.status === 'pending' || result.status === 'subscribed')) {
          done = true; section.dataset.keepPosted = 'yes';
          if (actions) actions.hidden = true;
          if (status) status.textContent = 'Lovely. We’ll keep you posted.';
          emit('keep_posted_accepted', { status: result.status });
        } else if (result && (result.status === 'suppressed' || result.status === 'no_email')) {
          done = true; section.hidden = true;
        } else if (status) status.textContent = failed;
      } catch (_) { if (status) status.textContent = failed; }
      finally { busy = false; if (!done) lock(false); }
    });
    var control = {
      show: async function () {
        section.hidden = true;
        if (done) return false;
        try {
          var result = await client.getNewsletter();
          if (result && result.status === 'eligible' && !done) { section.hidden = false; lock(false); emit('keep_posted_viewed'); return true; }
        } catch (_) { /* Optional ask: never blocks the success screen. */ }
        return false;
      },
      hide: function () { section.hidden = true; },
      isActive: function () { return !section.hidden; }
    };
    section.__keepPosted = control;
    return control;
  }

  return { create: create, keepPosted: keepPosted, ApiError: ApiError, publishMe: publishMe, ME_KEY: ME_KEY, ME_TTL: ME_TTL, TOKEN_KEY: TOKEN_KEY, TOKEN_RE: TOKEN_RE, MEMBER_KEY: MEMBER_KEY, validPreseedToken: validPreseedToken, PRESEED_TOKEN_RE: PRESEED_TOKEN_RE };
});
